@if (!dataConnectionError && status === 'loaded') {
    @if (chartOptions) {
        <div class="highcharts-chart-container d-flex align-items-center">
            @if (showAssetChart$ | ngrxPush) {
                <highcharts-chart
                    class="h-100 w-100"
                    [class.me-3]="!columnMode"
                    [Highcharts]="Highcharts"
                    [options]="chartOptions"
                    data-cy="assets-pie-chart"
                ></highcharts-chart>
            }
        </div>
    }

    @if (colDefs) {
        <ag-grid-angular
            wdxUtilsAgGridTheme
            [class.ms-3]="!columnMode"
            [rowData]="rowData"
            [columnDefs]="colDefs"
            [gridOptions]="gridOptions"
            class="w-100"
            data-cy="assets-table"
        >
        </ag-grid-angular>
    }
} @else {
    <wdx-portfolio-not-loaded
        [status]="dataConnectionError ? 'dataConnectionError' : status"
        [connectionErrorMessage]="dataConnectionError?.detail ?? ''"
        [dataTypeLabel]="dataTypeLabel"
    ></wdx-portfolio-not-loaded>
}
